document.addEventListener('DOMContentLoaded', () => {
  const carousel = new Carousel(document.getElementById('recently_viewed_slider'), {
    infinite: false,
    Dots: false,
    Navigation: false,
  });

  document
    .querySelector('.recently-viewed-products_container .slider-button.slider-button--prev')
    ?.addEventListener('click', () => carousel.slidePrev());
  document
    .querySelector('.recently-viewed-products_container .slider-button.slider-button--next')
    ?.addEventListener('click', () => carousel.slideNext());
});
